import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';
import StorageList from './msList--AccountAdmin--Storage';
import SecurityList from './msList--AccountAdmin--Security';

const styles = () => ({
    subheading: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
    subheadingActive: {
        maxHeight: '40px',
        color: 'rgba(0, 0, 0, 0.95)',
        fontSize: '0.875rem',
        lineHeight: '1.46429em',
    },
    chevron: {
        fill: '#262626',
        marginRight: '-0.5rem',
    },
});

class MSListAccountAdmin extends React.Component {
    state = {
        openStorage: false,
        openSecurity: false,
    };
    handleClickStorage = (event) => {
        let current = !this.state.openStorage;
        if (!event) {
            current = true;
        }
        this.setState({
            openStorage: current,
        });
    };
    handleClickSecurity = (event) => {
        let current = !this.state.openSecurity;
        if (!event) {
            current = true;
        }
        this.setState({
            openSecurity: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/account-administration/creating-portals"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Creating Portals" />
                            </ListItem>
                        </NavLink>

                        <NavLink onClick={this.preventAction} to="/media-shuttle/account-administration/storage/">
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Portal Storage" />
                            </ListItem>
                        </NavLink>

                        <StorageList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickStorage();
                                this.props.onActive();
                            }}
                        />

                        <NavLink onClick={this.preventAction} to="/media-shuttle/account-administration/security/">
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Portal Security" />
                            </ListItem>
                        </NavLink>

                        <SecurityList
                            isOpen="true"
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickSecurity();
                                this.props.onActive();
                            }}
                        />
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

MSListAccountAdmin.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(MSListAccountAdmin);
